import { Box, TextField, type TextFieldProps } from '@ui-lib';

import { ExplanationPill } from './ExplanationPill';
import { LockButton } from './LockButton';

export interface LockableTextFieldProps extends Omit<TextFieldProps, 'adornment' | 'adornmentPosition'> {
  locked?: boolean;
  toggleLocked?: () => void;
  explanation?: string;
}

export const LockableTextField = ({
  ref: forwardedRef,
  locked,
  toggleLocked,
  explanation,
  ...restProps
}: LockableTextFieldProps & {
  ref?: React.Ref<HTMLInputElement>;
}) => (
  <TextField
    ref={forwardedRef}
    disabled={locked}
    adornment={
      locked !== undefined ? (
        <Box marginRight="xsmall" display="flex" flexDirection="row" alignItems="center">
          {explanation && locked && <ExplanationPill>{explanation}</ExplanationPill>}
          <LockButton locked={locked} toggleLocked={toggleLocked} />
        </Box>
      ) : undefined
    }
    adornmentPosition="right"
    {...restProps}
  />
);

LockableTextField.displayName = 'LockableTextField';
